<div class="stack-panel-host" *ngIf="panels$ | async as panels">
  <ng-container *ngFor="let panel of panels; let index = index; trackBy: trackByPanelId">
    <div class="stack-panel-layer" [style.z-index]="getLayerZIndex(index)">
      <button
        type="button"
        class="stack-panel-backdrop"
        aria-label="Close stack panel"
        (click)="onBackdropClick(panel)"
      ></button>

      <section
        class="stack-panel"
        role="dialog"
        aria-modal="true"
        [ngClass]="panel.panelClass"
        [style.width]="panel.panelWidth"
      >
        <ng-container
          *ngComponentOutlet="panel.component; injector: panel.injector; inputs: panel.initialState"
        ></ng-container>
      </section>
    </div>
  </ng-container>
</div>
